<template>
    <div>
        <b-sidebar backdrop aria-labelledby="sidebar-no-header-title" no-header id="add_outreceipt" width="50rem" style="direction:ltr" right title="سند صرف" shadow >
    <template #default="{ hide }">
      <div class="m-1 text-start" style="direction:rtl">
        <div style="width:150px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
          <span>{{ pageTitle }}</span>
        </div>
        <div @click="hide" id="ohidid" style="float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
          <span>{{$parent.lang.close}}</span>
      </div>
    </div>
            <v-divider></v-divider>
            <v-form ref="addform">
            <div class="px-3 py-2" style="direction:rtl">
                <v-row>
                    <v-col cols="12" md="4" sm="12">
                        <lable>{{ $parent.lang.date }}</lable>
                        <b-form-input type="date"
                            ref="dialog"
                            class="inborder"
                            v-model="date"
                            :return-value.sync="date"
                            persistent
                            width="290px"
                        />
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <lable>{{ $parent.lang.account_name }}</lable>
                        <b-form-input v-model="account" style="background: rgb(195, 217, 255);" class="inborder" autocomplete="off" list="classes-list" @change="getaccountname(item.classid + ' - ' + item.namear)"></b-form-input>
                        <datalist id="classes-list">
                            <option v-for="(item,index) in classes" :key="index">{{item.classid}} - {{ item.namear }}</option>
                        </datalist>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <lable>{{ $parent.lang.mobile }}</lable>
                        <b-form-input class="inborder"
                            v-model="mobile"
                            :label="$parent.lang.mobile"
                        />
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <lable>{{ $parent.lang.full_name }}</lable>
                        <b-form-input class="inborder"
                            v-model="full_name"
                        />
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <lable>{{ $parent.lang.company_vatid }}</lable>
                        <b-form-input class="inborder"
                            v-model="vatid"
                        />
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <lable>{{ $parent.lang.total_amount }}</lable>
                        <b-form-input class="inborder"
                            v-model="received_total"
                        />
                    </v-col>
                    <v-col cols="12" md="3" sm="12" style="display:none;">
                        <lable>{{ $parent.lang.description }}</lable>
                        <b-form-select class="selborder"
                            v-model="selected"
                            :options="resons"
                        ></b-form-select>
                        
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <lable>{{ $parent.lang.paytypes }}</lable>
                        <b-form-select class="selborder"
                            v-model="paytype"
                            :options="paytypes"
                            ></b-form-select>
                    </v-col>
                    <!-- <v-col cols="12" md="4" sm="12">
                        <v-select
                            item-text="text"
                            item-value="value"
                            v-model="vselected"
                            :items="vatopt"
                            label="سبب الصرف"
                            :rules="fieldRules"
                        ></v-select>
                    </v-col> -->
                    <v-col cols="12" md="6" sm="12">
                        <label>{{ $parent.lang.notes }}</label>
                        <b-form-textarea class="inborder"
                            v-model="notes"
                            :rules="fieldRules"
                        ></b-form-textarea>
                    </v-col>
                </v-row>
            </div>
        </v-form>
        </template>
            <template #footer="" class="shadow">
                <div class="d-flex text-light align-items-center px-3 py-2">
                <b-button type="button" variant="success" @click="addVoucher()" class="ma-2" style="width:100px;">{{$parent.lang.add}}</b-button>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>


<script>
import axios from 'axios';
import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';

export default{
    data() {
        return {
            account_name: '',
            account: '',
            classes: [],
            id: 0,
            fieldRules: [
                v => !!v || 'الحقل مطلوب',
            ],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            modal: false,
            mobile: '',
            full_name:'',
            received_total:'',
            notes:'',
            selected:null,
            vselected:null,
            paytype: null,
            paytypes: [],
            options:[],
            voptions:[],
            voutcher_reson:'',
            vatid: '',
            resons:[
            ],
            vatopt:[
                {
                    value: 1,
                    text: 'لا تحتوي على ضريبة'
                },
                {
                    value: 2,
                    text: 'المبلغ شامل الضريبة'
                },
                {
                    value: 3,
                    text: 'المبلغ غير شامل الضريبة'
                },
            ],
            pageTitle: 'سند صرف',
        }
    },
    created(){
        this.getTypes();
        this.getclasses();
    },
    methods: {
        getaccountname(vars){
            this.account_name = vars;
        },
        getclasses() {
            const post = new FormData();
            post.append("type","getPostedCOA")
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$COOKIEPhase))
            post.append("data[lang]",this.$parent.lang.langname);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {  
                const res = response.data;    
                this.classes = res.results.data;
            });
        },
        getTypes(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type",'getExpenses');
            post.append("auth",this.$cookies.get(this.$COOKIEPhase));
            post.append('data[type]',2)
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then(
                (response) => {
                    this.resons = response.data.results.data;
                    this.paytypes = response.data.results.paytypes;
                    
                    this.paytype = response.data.results.paytypes[0].value ?? null;
                }
            );
        },
        getVouter(id){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type",'getVoucherById');
            post.append("auth",this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',id)
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then(
                (response) => {
                    this.id = id;
                    this.date = response.data.results.data[0].receipt_date
                    this.modal = false
                    this.mobile = response.data.results.data[0].received_mobile
                    this.full_name = response.data.results.data[0].received_from
                    this.notes = response.data.results.data[0].pay_reson
                    this.paytype = response.data.results.data[0].paytype
                    this.selected = response.data.results.data[0].selected
                    this.vselected =null;
                    this.options =[];
                    this.voptions =[];
                    this.received_total =response.data.results.data[0].ftotal;
                    this.vatid =response.data.results.data[0].vatid;
                }
            );
        },
        resetAll(){
            this.account = '';
            this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            this.modal = false;
            this.mobile = '';
            this.full_name ='';
            this.received_total ='';
            this.notes ='';
            // this.paytype = null;
            this.selected =null;
            this.vselected =null;
            this.options =[];
            this.voptions =[];
            this.voutcher_reson ='';
            this.id =0;
            this.getclasses();
            this.pageTitle = "سند صرف";
        },
        checkData(){
            // if(typeof document.getElementById('add_outreceipt') !== 'undefined'
            //     || !!document.getElementById('add_outreceipt') != true
            // )
            // {
            //     if(document.getElementById('add_outreceipt').style.display != 'none'){
            //         if(this.received_total == 0){
            //             //this.received_total = this.$parent.cardrows[this.$parent.activeClick].remaining;
            //         }
            //     }else{
            //         this.received_total = 0;
            //     }
            // }
        },
        addVoucher(){
            if(!this.$refs.addform.validate()){

                return false;
            }
            if(this.account == ''){
                this.$snotify.create({
                title: ' ',
                    body: 'يجب اختيار حساب قبل المتابعة',
                    config: {
                        position: SnotifyPosition.leftTop,
                        type: SnotifyStyle.success,
                        timeout: 5000,
                        showProgressBar: true,
                        closeOnClick: true,
                    }
                })
                return false;
            }
            if(this.full_name == ''){
                this.$snotify.create({
                title: ' ',
                    body: 'يجب اضافة اسم المستلم',
                    config: {
                        position: SnotifyPosition.leftTop,
                        type: SnotifyStyle.success,
                        timeout: 5000,
                        showProgressBar: true,
                        closeOnClick: true,
                    }
                })
                return false;
            }
            if(this.amount == ''){
                this.$snotify.create({
                title: ' ',
                    body: 'يجب اضافة المبلغ المسلم',
                    config: {
                        position: SnotifyPosition.leftTop,
                        type: SnotifyStyle.success,
                        timeout: 5000,
                        showProgressBar: true,
                        closeOnClick: true,
                    }
                })
                return false;
            }
            if(this.notes == ''){
                this.$snotify.create({
                title: ' ',
                    body: 'يرجى اضافة وصف للعملية',
                    config: {
                        position: SnotifyPosition.leftTop,
                        type: SnotifyStyle.success,
                        timeout: 5000,
                        showProgressBar: true,
                        closeOnClick: true,
                    }
                })
                return false;
            }
             let balance = 0;
             for(let i=0;i<this.paytypes.length;i++){
                if(this.paytypes[i].value == this.paytype) balance = this.paytypes[i].balance;
             }
             if(parseFloat(this.received_total) > parseFloat(balance && this.$store.state.licenseType.allowPayInCredit)){
                this.$snotify.create({
                title: ' ',
                    body: 'لايمكن استخدام طريقة دفع بدون رصيد',
                    config: {
                        position: SnotifyPosition.leftTop,
                        type: SnotifyStyle.danager,
                        timeout: 5000,
                        showProgressBar: true,
                        closeOnClick: true,
                    }
                })
                return false;
            }
            if(this.account == this.paytype) {
                this.$snotify.create({
                title: ' ',
                    body: 'لا يمكن ان يكون الحساب الدائن نفس الحساب المدين',
                    config: {
                        position: SnotifyPosition.leftTop,
                        type: SnotifyStyle.danager,
                        timeout: 5000,
                        showProgressBar: true,
                        closeOnClick: true,
                    }
                })
                return false;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type",'addOVouchter');
            post.append("auth",this.$cookies.get(this.$COOKIEPhase));
            post.append('data[type]',2)
            post.append('data[mobile]',this.mobile)
            post.append('data[full_name]',this.full_name)
            post.append('data[amount]',this.received_total)
            post.append('data[notes]',this.notes)
            post.append('data[date]',this.date)
            post.append('data[selected]',this.selected)
            post.append('data[vselected]',this.vselected);
            post.append('data[paytype]',this.paytype);
            post.append('data[vatid]',this.vatid);
            post.append('data[id]',this.id);
            post.append('data[account]',this.account);
            // post.append('data[doc_type]',"");
            // post.append('data[dailydate]',this.$parent.cardrows[this.$parent.activeClick].edate ?? 0);
            // post.append('data[dailyid]',this.$parent.cardrows[this.$parent.activeClick].id ?? 0);
                       
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then(
                (response) => {
                    const res = response.data;
                    
                    if (this.$snotify.notifications.length > 0) {
                        this.$snotify.notifications.forEach(notification => {
                            this.$snotify.remove(notification.id)
                        });
                    }
                    this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
                    this.modal = false;
                    this.mobile = '';
                    this.full_name ='';
                    this.received_total ='';
                    this.notes = '';
                    this.$snotify.create({
                    title: ' ',
                        body: this.$parent.lang.added_successfuly,
                        config: {
                            position: SnotifyPosition.leftTop,
                            type: SnotifyStyle.success,
                            timeout: 5000,
                            showProgressBar: true,
                            closeOnClick: true,
                        }
                    })
                    document.getElementById('ohidid').click();
                    this.$parent.getVouchers();
                }
            )
        }
    },
}
</script>
<style>
.v-input__icon--append i{
    font-size:3em !important;  
    color:red !important;
}
</style>